import script from "./form_news.vue?vue&type=script&setup=true&lang=ts"
export * from "./form_news.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__